// Constants and utilities for Silica Loads components
import { getTodayString } from '../../utils/dateUtils';

export const CLIENT_OPTIONS = ['SVE CASTINGS PVT LTD', 'BALAJI CASTINGS PVT LTD'];
export const DELIVERY_STATUSES = ['in_progress', 'delivered'];
export const WEIGHT_STATUSES = ['addition', 'deduction'];

export const initialFormData = {
  date: getTodayString(),
  material_from: 'Plant',
  purchase_order: '',
  vehicle_number: '',
  driver_name: '',
  driver_contact: '',
  transport_company: '',
  client_name: '',
  sve_load_type: '',  // For SVE: 'General', 'Addition', or 'Deduction'
  delivery_status: '',  // Empty by default - user must select
  acceptance_status: '',  // Empty by default - user must select
  afs_specification: '',
  date_sent: new Date().toISOString().split('T')[0],
  date_received: '',
  bill_payment_date: '',
  follow_up_email: '',
  follow_up_emails: [],
  follow_up_phone: '',
  bill_status: '',  // Empty by default - user must select
  invoice_number: '',
  invoice_amount: '',
  tons: '',
  updated_invoice_amount: '',
  updated_invoice_number: '',
  total_tons: '',
  total_kgs_updated: '',
  total_tons_updated: '',
  delivered_tons: '',
  pending_tons: '',
  final_invoice_amount: '',
  weight_status: '',
  additional_invoice_amount: '',
  addition_invoice_number: '',
  deduction_invoice_number: '',
  addition_invoice: '',
  additional_tons: '',
  additional_kgs: '',
  deduction_tons: '',
  deduction_kgs: '',
  deduction_invoice_amount: '',
  rejection_reason: '',
  lab_report: '',
  payment_due_days: 45,
  initial_due_days: '',
  expected_payment_date: '',
  actual_payment_date: '',
  past_due: 'no',
  same_as_expected: false,
  // Invoice generation fields (totals for backward compatibility)
  product: 'Silica sand dry',
  kgs: '',      // Total kgs (kgs_1 + kgs_2 when invoice_count=2)
  rate: '',     // Shared rate
  generated_invoice_number: '',  // For single invoice mode
  generated_invoice_amount: '',  // Total amount for backward compatibility
  generated_invoice_file: '',    // For single invoice mode
  
  // Multiple invoices support (BALAJI only)
  invoice_count: '',  // Empty by default - user must select
  
  // Invoice 1 fields
  kgs_1: '',
  tons_1: '',
  invoice_amount_1: '',
  generated_invoice_number_1: '',
  generated_invoice_amount_1: '',
  generated_invoice_file_1: '',
  
  // Invoice 2 fields
  kgs_2: '',
  tons_2: '',
  invoice_amount_2: '',
  generated_invoice_number_2: '',
  generated_invoice_amount_2: '',
  generated_invoice_file_2: '',
  
  // Updated invoice generation fields (Balaji)
  generated_updated_invoice_number: '',
  generated_updated_invoice_amount: '',
  generated_updated_invoice_file: '',
  // Addition invoice generation fields (SVE)
  generated_addition_invoice_number: '',
  generated_addition_invoice_amount: '',
  generated_addition_invoice_file: '',
  // Deduction invoice generation fields (SVE)
  generated_deduction_invoice_number: '',
  generated_deduction_invoice_amount: '',
  generated_deduction_invoice_file: '',
  // Manual invoice number override fields
  manual_invoice_number: '',
  manual_invoice_number_1: '',
  manual_invoice_number_2: '',
  manual_updated_invoice_number: '',
  manual_addition_invoice_number: '',
  manual_deduction_invoice_number: '',
  manual_summary_invoice_number: ''
};

// Prevent scroll wheel from changing number input values
export const preventWheelChange = (e) => {
  e.target.blur();
};
